exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.autocomplete .v-select__selection.v-select__selection--comma {\n    display: none !important;\n}\n", ""]);
